<div class="projects mb-4" *ngIf="!simulacion">
    <div class="card">
        <div class="card-header header-background">
            <div class="row">
                <div class="col-sm-3">
                    <h2>Plan de Mejora</h2>
                </div>
            </div>
        </div>

        <div *ngIf="region == null" >
            <ul class="nav nav-tabs">
                <li class="nav-item">
                    <a class="nav-link active" data-bs-toggle="tab" href="#resumen">Resumen</a>
                </li>
                <li class="nav-item">
                    <a class="nav-link" data-bs-toggle="tab" (click)="showDetalle = true" href="#detalle">Detalle</a>
                </li>
            </ul>

            <div id="myTabContent" class="tab-content">
                <div class="tab-pane fade show active" id="resumen">
                    <div style="padding: 20px 50px;">
                        <div class="row">
                            <app-plan-resumen></app-plan-resumen>
                        </div>
                    </div>
                </div>

                <div class="tab-pane fade show" id="detalle">
                    <div style="padding: 20px 50px;">
                        <div class="row">
                            <app-plan-seguimiento *ngIf="showDetalle"></app-plan-seguimiento>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div *ngIf="region != null" >
            <app-plan-seguimiento [region]="region" ></app-plan-seguimiento>
        </div>
    </div>
</div>


<div *ngIf="simulacion">
    <app-simulacion-plan-mejora></app-simulacion-plan-mejora>
</div>
